import moment from "moment";
import { STOCK_TYPE_NAME } from "@/constants/productStock";

export function hasPhysicalCountInSelectedDate(
  stockAdjustmentList,
  selectedDate,
  excludeId = null,
  options = {}
) {
  if (!stockAdjustmentList || !Array.isArray(stockAdjustmentList) || !selectedDate) {
    return false;
  }

  const { types = [STOCK_TYPE_NAME.PHYSICAL_COUNT] } = options;

  const selectedYMD = moment(selectedDate).format("YYYY-MM-DD");

  const duplicate = stockAdjustmentList.find(item => {
    // Check both transactionDt and transactionDate to be safe
    const itemTransactionDate = item.transactionDt || item.transactionDate;

    if (!types.includes(item.type) || !itemTransactionDate) {
      return false;
    }

    if (item.status === "CANCELED") {
      return false;
    }

    if (excludeId && item.id === excludeId) {
      return false;
    }

    const itemDateStr = moment(itemTransactionDate).format("YYYY-MM-DD");

    return itemDateStr === selectedYMD;
  });

  return !!duplicate;
}

export function getLatestPhysicalCountDate(stockAdjustmentList, excludeId = null) {
  if (!stockAdjustmentList || !Array.isArray(stockAdjustmentList)) {
    return null;
  }

  const physicalCounts = stockAdjustmentList.filter(item => {
    const itemTransactionDate = item.transactionDt || item.transactionDate;
    return (
      item.type === STOCK_TYPE_NAME.PHYSICAL_COUNT &&
      itemTransactionDate &&
      item.status !== "CANCELED" &&
      (!excludeId || item.id !== excludeId)
    );
  });

  if (physicalCounts.length === 0) {
    return null;
  }

  // Sort by date descending
  const sorted = physicalCounts.sort((a, b) => {
    const dateA = moment(a.transactionDt || a.transactionDate).valueOf();
    const dateB = moment(b.transactionDt || b.transactionDate).valueOf();
    return dateB - dateA;
  });

  return new Date(sorted[0].transactionDt || sorted[0].transactionDate);
}

export function getAdjustmentPeriodFromTransactionDt(
  stockAdjustmentList,
  transactionDt,
  options = {}
) {
  if (!stockAdjustmentList || !Array.isArray(stockAdjustmentList) || !transactionDt) {
    return null;
  }

  const { types = [STOCK_TYPE_NAME.PHYSICAL_COUNT] } = options;

  const transactionMoment = moment(transactionDt);
  const selectedYMD = transactionMoment.format("YYYY-MM-DD");

  const pcOnDate = stockAdjustmentList.find(item => {
    const itemTransactionDate = item.transactionDt || item.transactionDate;
    if (!types.includes(item.type) || !itemTransactionDate || item.status === "CANCELED") {
      return false;
    }
    return moment(itemTransactionDate).format("YYYY-MM-DD") === selectedYMD;
  });

  if (!pcOnDate) return null;

  const pcMoment = moment(pcOnDate.transactionDt || pcOnDate.transactionDate);

  if (transactionMoment.isBefore(pcMoment)) {
    return "BEFORE";
  } else {
    return "AFTER";
  }
}
